import AdminDashboard from "../layouts/AdminDashboard/AdminDashboard";

export const adminRoutes = [ { path: "/", name: "Home", component: AdminDashboard } ];


